import { VisitorsRecord } from '../VisitorsRecord';
import moment from 'moment';
import { FView } from '@/core/FView';
import { DataType } from '../../DataType';

export class WeekRecordGroup {
    public Records: VisitorsRecord[] = [];

    public formatDescription(): string {
        let firstDayRecord:VisitorsRecord = this.Records.find(r => !!r) as VisitorsRecord;
        let lastDayRecord:VisitorsRecord =  this.Records.slice(-1)[0] as VisitorsRecord;
        
        let from = moment(firstDayRecord.stat_date);
        let fromDate = from.format("DD.MM");
        let toDate = moment(lastDayRecord.stat_date).format("DD.MM");
        let weekNum = from.isoWeek();

        return `#${ weekNum } (${ fromDate } − ${ toDate })`;
    }

    public static getVisitorsByWeeks(): WeekRecordGroup[] {
        let dataSet: VisitorsRecord[] = FView.Get().dataManager.GetDataset(DataType.VisitorsDaily);
        let weekDataSet: WeekRecordGroup[] = [];

        let lastGroup!: WeekRecordGroup;
        let lastDate!: moment.Moment;

        for (let record of dataSet) {
            let currentDate = moment(record.stat_date);
            if (lastDate == null || lastDate.isoWeekday() >= currentDate.isoWeekday()) {
                if (lastGroup != null) {
                    weekDataSet.push(lastGroup);
                }
                lastGroup = new WeekRecordGroup();
            }
            lastDate = currentDate;
            lastGroup.Records[currentDate.isoWeekday()] = record;
        }

        if (lastGroup != null) {
            weekDataSet.push(lastGroup);
        }
        
        return weekDataSet;
    }
}
